import axios from '@/utils/axios';
import { ip3 } from '@/utils/constants';
import type {ThucPhamBaoCao} from "@/services/ThucPham/BaoCao";
import moment from "moment-timezone";

export async function getBaoCao(payload: ThucPhamBaoCao.XuatBaoCao) {
  return axios.get(`${ip3}/export-file/thucpham/baocao`, {
    params: {
      ...payload,
      startDate: moment.isMoment(payload.startDate)?payload.startDate.format():payload.startDate,
      endDate: moment.isMoment(payload.endDate)?payload.endDate.format():payload.endDate,
    }
  });
}
